module.exports = "/static/media/empty-state.de811e87.svg";